import { render, staticRenderFns } from "./AddMedicalAdvice.vue?vue&type=template&id=f1a0241a&scoped=true"
import script from "./AddMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./AddMedicalAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a0241a",
  null
  
)

export default component.exports